import Swiper from "swiper";
import { Navigation } from "swiper/modules";

jQuery(($) => {

    if($(".booom-partner-slider__slider").length) {
        new Swiper('.booom-partner-slider__slider', {
            modules: [Navigation],
            spaceBetween: 20,
            slidesPerView: 1.4,
            navigation: {
                nextEl: `.booom-partner-slider__slider-next-button`,
                prevEl: `.booom-partner-slider__slider-previous-button`,
            },
            //loop: true,
            speed: 500,
            breakpoints: {
                320: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
                768: {
                    spaceBetween: 25,
                    slidesPerView: 2,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
            },
        });
    }
});
